import { DckSelectors } from "dck-redux"
import React, { Component } from "react"
import Spinner from "react-spinkit"
import * as ItemTypes from "../../../redux/items/types"
import { 
  Col,
  Modal,
  Button,
  Alert
} from "react-bootstrap"
import { connect } from "react-redux"

class CheckUserActivity extends Component {

  state = {
    toUsername: '',
  }

  getTitle = () => {

    const { activity, user, nbLoan } = this.props

    switch(activity) {
      case 0:
        return 'Checking activities the user is linked to'
      case 1:
        return `${user.name} has ${nbLoan} loan${nbLoan > 1 ? 's' : ''} 
        assigned to him, before proceeding with the deletion`
      default:
        return 'No activity related to the user was found. Are you sure you want to continue ?'
    }
  }

  render() {

    const { show, close, user, activityError, activityRunning, activity, users, assignToUsername,
      confirmRemoval, } = this.props,
    { toUsername } = this.state

    return (
      <Modal show={ show } onHide={ close }>

        <Modal.Header closeButton>
          <Modal.Title>
            Removing user <strong>{ user.name }</strong>
            &nbsp;({ user.username })
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{ this.getTitle() } </p>
          <Col>
          { activityError ?
            <Alert bsStyle="danger">
              <strong>{ activityError }</strong>
            </Alert>
            : 
            activityRunning ?
            <Alert bsStyle="info">
              Please wait .. <Spinner name="ball-beat" className="inline" />
            </Alert>
            : null
          }
          </Col>

          { activity === 1 ?
            <div>
              Assign To &nbsp;
              <select
                className="assignToSelect"
                value={ toUsername }
                onChange={e => this.setState({ toUsername: e.target.value })}>
                <option value=""></option>
                { users.map(user => 
                    <option key={user.username} value={user.username}>{user.name} ({user.username})</option>
                  )
                }
              </select> &nbsp;
              <Button onClick={() => assignToUsername( user.username, toUsername) }
                disabled={ activityRunning }>OK</Button>
              <br/>
              <small className="gray">(:) Leave blank to unassign.</small>
            </div>
            : null
          }
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={ close }>Cancel</Button>
          <Button bsStyle="danger" onClick={ confirmRemoval }
            disabled={ activityRunning || activityError || activity !== 2 }>
            Remove
          </Button>
        </Modal.Footer>

      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => {

  let users = DckSelectors.selectAllItems(state, ItemTypes.User)

  // Filter the same user type and without the current user
  users = users.filter(user =>
    user.userRole === (ownProps.user.userRole)
    && user.username !== ownProps.user.username)
  return { users }
}

export default connect(mapStateToProps)(CheckUserActivity)



// WEBPACK FOOTER //
// ./src/components/Users/UserTable/CheckUserActivity.js